import { Sparkle } from "lucide-react";

const WORDS = ["Ordinateurs", "Imprimantes", "Logiciels de gestion", "Réseau & Wi-Fi", "Consommables", "Maintenance", "Accessoires", "Devis sur mesure"];

export const Marquee = ({ dark = false }) => (
  <div data-testid="marquee" className={`overflow-hidden border-y ${dark ? "border-white/10 bg-navy text-white" : "border-navy/10 bg-white text-navy"} py-5`}>
    <div className="marquee-track">
      {[0, 1].map((k) => (
        <div key={k} className="flex shrink-0 items-center">
          {WORDS.map((w, i) => (
            <span key={`${k}-${i}`} className="flex items-center gap-8 px-8">
              <span className={`font-serif text-xl italic sm:text-2xl ${i % 2 ? "text-gold" : ""}`}>{w}</span>
              <Sparkle className="h-3.5 w-3.5 text-gold" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
